import * as IBANTools from 'ibantools'

export function normalizeIBAN(maybeIBAN: string) {
  const normalizedIBAN = IBANTools.electronicFormatIBAN(
    maybeIBAN.replace(/\s/g, ''),
  )
  return normalizedIBAN
}

export function isValidIBAN(maybeIBAN: string) {
  const normalized = normalizeIBAN(maybeIBAN)
  if (!normalized) return false
  return IBANTools.isValidIBAN(normalized)
}

export function isValidBIC(maybeBIC: string) {
  return /^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(maybeBIC)
}

export function normalizeBIC(maybeBIC: string) {
  return maybeBIC.replace(/\s/g, '').toUpperCase()
}
